var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"an-content"},[_c('an-content-header'),(!_vm.report.noOptions)?_c('an-content-controls'):_vm._e(),(!_vm.loading)?_c('an-content-layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }